// extracted by mini-css-extract-plugin
module.exports = {"day":"day-module--day--21rzn","btn":"day-module--btn--1Kel7"};